import { SiteNavLink } from '@vcd-ecm-ui/LeftNav';

export const LINKS : SiteNavLink[] = [
  {
    displayText: 'Certificates',
    value: '/certificates',
    icon: 'i-dashboard-pdf',
  },
  {
    displayText: 'EC Wizard',
    value: '/ecwizard',
    icon: 'i-enterprise',
    subLinks: [
      {
        displayText: 'Wizard Settings',
        value: '/ecwizard/settings',
      },
      {
        displayText: 'Sellers',
        value: '/ecwizard/sellers',
      },
      {
        displayText: 'Jurisdictions',
        value: '/ecwizard/jurisdictions',
      },
      {
        displayText: 'Products',
        value: '/ecwizard/products',
      },
      {
        displayText: 'Exemption Types',
        value: '/ecwizard/exemption-types',
      },
    ],
  },
  {
    displayText: 'Customers',
    value: '/customers',
    otherValues: ['customer/view/', 'customer/edit/', 'customer/add'],
    icon: 'i-account',
  },
  {
    displayText: 'Settings',
    value: '/settings',
    icon: 'i-tax-setup',
    subLinks: [
      {
        displayText: 'Certificate Settings',
        value: '/settings/certificate/1',
      },
      {
        displayText: 'Customer Settings',
        value: '/settings/customer/1',
      },
      {
        displayText: 'User Setup',
        value: '/settings/users',
      },
      {
        displayText: 'Taxpayer Setup',
        value: '/settings/taxpayers',
      },
    ],
  },
  {
    displayText: 'Reports',
    value: '/reports',
    icon: 'i-reporting',
    subLinks: [
      {
        displayText: 'Certificate Reports',
        value: '/reports/certificates',
      },
      {
        displayText: 'Audit Reports',
        value: '/reports/audits',
      },
      {
        displayText: 'Custom Reports',
        value: '/reports/customs',
      },
      {
        displayText: 'Activity Log',
        value: '/reports/activity-log',
      },
      {
        displayText: 'Error Log',
        value: '/reports/error-log',
      },
    ],
  },
  {
    displayText: 'Correspondence',
    value: '/correspondence',
    icon: 'i-mail',
    subLinks: [
      {
        displayText: 'Templates',
        value: '/correspondence/templates',
      },
      {
        displayText: 'Subscriptions',
        value: '/correspondence/subscriptions',
      },
      {
        displayText: 'Configuration',
        value: '/correspondence/configuration/status',
      },
    ],
  },
];

export default { LINKS };
